import React, { Component } from "react";
import { history } from "../../../helpers";
import BankDetailsView from "./BankDetailsView";

export default class BankDetailsContainer extends Component {
  render() {
    const { details } = this.props;
    return (
      <>
        {details && (
          <BankDetailsView details={details} />
        )}
      </>
    );
  }
}
